<template>
  <div :style="[customCss]" class="section-bg-color rounded-r-lg h-full">
    <div class="flex text-sm flex justify-between px-5 py-7 relative inter-font-regular">
      <div class="playlist-label font-semibold heading-color">
        <slot name="title"></slot>
      </div>
      <div class="lesson-count font-semibold heading-color">
        <slot name="lessons-count"></slot>
      </div>
    </div>
    <div class="custom-scrollbars">
      <slot name="lessons-list"> </slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LessonPlaylist',
  props: {
    getThemeSettings: {},
  },
  computed: {
    themeSettings() {
      return this.getThemeSettings();
    },
    customCss() {
      return {
        '--template-section-bg-color':
          this.themeSettings.configuration_options.section_bg_color,
       // '--template-body-bg-color': this.themeSettings.body_section.bg_color,
        '--hierarchy-heading-color': this.themeSettings.configuration_options
          .section_heading_color,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.section-bg-color {
  background-color: var(--template-section-bg-color);
}
.heading-color{
  color: var(--hierarchy-heading-color);
}
.playlist-label {
  .back-icon {
    transform: rotate(180deg);
    margin-top: -1px
  }
}
</style>